import { loginSteps } from '@/mocks/homepage';

export default function GuideSection() {
  return (
    <section className="py-16 md:py-20 bg-secondary-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            安全登录指引
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            只需四步，安全快速地登录98堂平台
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {loginSteps.map((stepItem) => (
            <div
              key={stepItem.step}
              className="relative p-6 rounded-lg bg-background-50 border border-secondary-200/60 group hover:border-primary-200 transition-all duration-300"
            >
              <div className="w-10 h-10 rounded-full bg-primary-500 text-white flex items-center justify-center font-bold text-sm mb-4">
                {stepItem.step}
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-2">
                {stepItem.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {stepItem.description}
              </p>
              <div className="absolute top-4 right-4 w-8 h-8 flex items-center justify-center opacity-10 group-hover:opacity-20 transition-opacity duration-300">
                <i className={`${stepItem.icon} text-2xl text-primary-500`} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}